import { GridOptionsContext } from '@contexts/grid-options'
import { ContentType } from '@entries/content-types'
import ContentfulContentArticle from '@entries/contentful-content-article'
import ContentfulFaqPageList from '@entries/contentful-faq-page-list'
import ContentfulReview from '@entries/contentful-review'
import ContentfulWrapperRichMedia from '@entries/contentful-wrapper-rich-media'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import Carousel from '@ui/carousel'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulPageSectionCarousel: Utils.EntryFC<
  Queries.ContentfulPageSectionCarouselFragment
> = ({ content: { contents } }) => (
  <GridOptionsContext.Provider
    value={{
      // Fix to emulate content article behavior
      col: { mobileS: 1, tablet: 1, laptop: 3, laptopL: 1 },
    }}
  >
    <Carousel>
      {contents?.map((content, index) => (
        <Carousel.Slide key={`slider-${index}`}>
          <Entry
            content={content}
            mapping={{
              [ContentType.ContentfulContentArticle]: ContentfulContentArticle,
              [ContentType.ContentfulWrapperRichMedia]:
                ContentfulWrapperRichMedia,
              [ContentType.ContentfulReview]: ContentfulReview,
              [ContentType.ContentfulFaqPageList]: ContentfulFaqPageList,
            }}
          />
        </Carousel.Slide>
      ))}
    </Carousel>
  </GridOptionsContext.Provider>
)

export const query = graphql`
  fragment ContentfulPageSectionCarousel on ContentfulSection {
    ...ContentfulEntry
    contents {
      ...ContentfulContentArticle
      ...ContentfulWrapperRichMedia
      ...ContentfulReview
      ...ContentfulFaqPageList
    }
  }
`

export default withDisplayName(
  ContentfulPageSectionCarousel,
  'ContentfulPageSectionCarousel'
)
